import { render, staticRenderFns } from "./RekycRequest.vue?vue&type=template&id=3fafa77a&scoped=true&"
import script from "./RekycRequest.vue?vue&type=script&lang=js&"
export * from "./RekycRequest.vue?vue&type=script&lang=js&"
import style0 from "./RekycRequest.vue?vue&type=style&index=0&id=3fafa77a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fafa77a",
  null
  
)

export default component.exports